"use client";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { usePowerSearch } from "../contexts/power-search-context";
import { ExtraActions } from "./ExtraActions";
import Skeleton from "react-loading-skeleton";

const ResultsCount = () => {
  const {
    searchResults,
    searchResultsLoading,
    totalPages,
    itemsPerPage,
    totalResults,
  } = usePowerSearch();
  if (searchResultsLoading || !searchResults.length) {
    return (
      <Col xs={12} md={4} className="">
        <Skeleton height={16} width={120} />
      </Col>
    );
  }
  if (searchResults.length === 0) {
    return (
      <Col xs={12} md={4} className="">
        <div />
      </Col>
    );
  }
  return (
    <Col xs={12} md={4} className="">
      <p className="mb-0 fw-bold text-dark">
        Showing {searchResults.length.toLocaleString()} of{" "}
        {totalResults.toLocaleString()} Results
      </p>
    </Col>
  );
};

const SearchResultsHeader = () => {
  const {
    searchResults,
    totalPages,
    itemsPerPage,
    totalResults,
    currentView,
    setCurrentView,

    currentUser,
  } = usePowerSearch();

  const institutionalUser =
    currentUser &&
    (currentUser.plan === "institutional" || currentUser.plan === "individual");

  const sortDropdownOptions = [
    { label: "Name", value: "name" },
    // { label: "Institution", value: "institutions" },
    // { label: "Role", value: "roles" },
    // { label: "Market Cap", value: "market_cap" },
    { label: "Relevance", value: "" },
  ];

  return (
    <div className="py-3">
      <Row className="align-items-center" style={{ margin: 0 }}>
        {/* Results Count */}
        <ResultsCount />

        {/* Controls */}
        <Col xs={12} md={8}>
          <div className="d-flex align-items-center justify-content-md-end">
            {/* View Toggle */}
            <div
              className="d-flex align-items-center "
              style={{ marginRight: "10px" }}
            >
              <Button
                size="sm"
                variant="ghost"
                onClick={() => setCurrentView("grid")}
                style={{
                  backgroundColor: currentView === "grid" ? "#EDECE6" : "white",
                  color: currentView === "grid" ? "#000" : "#000",
                  border: "1px solid #dee2e6",
                  outline: "none",
                }}
              >
                <i className="fa fa-th-large" style={{ fontSize: "12px" }} />
              </Button>
              <div
                style={{
                  borderRight: "1px solid #dee2e6",
                  margin: "0 10px",
                  padding: "4px 0",
                  alignSelf: "stretch",
                  outline: "none",
                }}
              />

              <Button
                size="sm"
                variant="ghost"
                onClick={() => setCurrentView("list")}
                style={{
                  backgroundColor: currentView === "list" ? "#EDECE6" : "white",
                  color: currentView === "list" ? "#000" : "#000",
                  border: "1px solid #dee2e6",
                }}
              >
                <i className="fa fa-list" style={{ fontSize: "12px" }} />
              </Button>
            </div>

            {/* <Dropdown>
              <Dropdown.Toggle
                size="sm"
                variant="light"
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  color: "#495057",
                  fontWeight: "500",
                  minWidth: "140px",
                  margin: "0 10px ",
                }}
              >
                Sort by: {selectedSortLabel}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {sortDropdownOptions.map((option) => (
                  <Dropdown.Item
                    size="sm"
                    key={option.value}
                    onClick={() => onSortDropdownChange(option)}
                    active={option.value === sortField}
                  >
                    {option.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown> */}
            <ExtraActions />

            {/* {institutionalUser && (
              <Dropdown>
                <Dropdown.Toggle
                  size="sm"
                  variant="light"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    color: "#495057",
                    fontWeight: "500",
                    marginLeft: "10px ",
                  }}
                >
                  Actions
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    size="sm"
                    onClick={() => fetchAllResultsForPrinting(null)}
                    disabled={
                      allSearchResultsLoading ||
                      (allSearchResults.length > 0 && !allSearchResultsLoading)
                    }
                  >
                    <i className="fa fa-plus me-2" />
                    {allSearchResultsLoading
                      ? "Loading..."
                      : allSearchResults.length > 0 && !allSearchResultsLoading
                      ? "Added to Power List"
                      : "Add to Power List"}
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item
                    size="sm"
                    onClick={handlePrintReportInternal}
                    disabled={allSearchResultsLoading || printing}
                  >
                    <i className="fa fa-print me-2" />
                    {printing
                      ? "Generating Report..."
                      : allSearchResultsLoading
                      ? "Fetching..."
                      : totalResults <= 500
                      ? "Print Results"
                      : "Print First 500"}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )} */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SearchResultsHeader;
